"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Loader_1 = __importDefault(require("../../Loader/Loader"));
var Container_1 = __importDefault(require("../../Container/Container"));
var Button = function (_a) {
    var children = _a.children, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.mode, mode = _c === void 0 ? 'plain' : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? '' : _e, automatedTestId = _a.automatedTestId, type = _a.type, _f = _a.palette, palette = _f === void 0 ? 'primary' : _f;
    var elementRef = react_1.useRef();
    function handleOnClick(event) {
        var _a;
        // @ts-ignore
        (_a = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        !disabled && onClick && onClick(event);
    }
    function handleOnMouseOver(event) {
        var _a;
        // @ts-ignore
        (_a = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        !disabled && onMouseOver && onMouseOver(event);
    }
    function handleOnMouseOut(event) {
        var _a;
        // @ts-ignore
        (_a = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        !disabled && onMouseOut && onMouseOut(event);
    }
    return (react_1.default.createElement(Container_1.default, { className: "sds-button-container " + className, onMouseOver: handleOnMouseOver, onMouseOut: handleOnMouseOut },
        react_1.default.createElement("button", { 
            // @ts-ignore
            ref: elementRef, className: "sds-button " + palette + " " + mode, onClick: handleOnClick, disabled: disabled, id: automatedTestId, testid: automatedTestId, "data-testid": automatedTestId, type: type },
            react_1.default.createElement(Container_1.default, { className: "sds-button-content " + (loading ? 'hide' : 'show') }, children),
            loading && react_1.default.createElement(Loader_1.default, null))));
};
exports.default = Button;
